/**
 * 4Talks - Swiper slider initialisations
 *
 * @author Matt Haynes
 * @package Joi Polloi
 *
 */

import Swiper, { Navigation, A11y } from 'swiper/core';

class SwiperSlider {
    constructor(elem) {
        if (!elem) return;

        this.elem = elem;
        this.init();
    }

    init() {
        Swiper.use([Navigation, A11y]);

        // eslint-disable-next-line no-unused-vars
        const swiper = new Swiper(this.elem, {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 20,
            watchOverflow: true,
            watchSlidesVisibility: true,
            // loop: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },

            // And if we need scrollbar
            // scrollbar: {
            //     el: '.swiper-scrollbar',
            // },
        });
    }
}

export default SwiperSlider;
